import React, { useEffect } from 'react';
import { Container, Grid, Typography, TextField, Button, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { actionGetBooking, actionResetBooking } from 'actions';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { useLocation } from "react-router-dom";
import {
    actionShopCartSetManageMyBooking, actionShopCartApplyMemberCostrate, actionShopCartResetDonation, actionShopCartResetStateWithTourHold
} from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetPaymentTransaction } from 'actions';

const { EmailRegex, FindMyBookingTitle, OrderItemsInCartError, InvalidFindMyBookingFieldsErrorMsg, FindBookingIDNumberNumbericOnly } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    content: {
        textAlign: 'center'
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    },
    boxBorder:
    {
        border: '4px solid ' + theme.palette.primary.main,
        borderRadius: '2px'
    },
    itemPadding: {
        padding: '15px'
    },
    searchButton: {
        marginBottom: '10px'
    }
}));


const FindMyBooking = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    //States Initializing Start

    const [state, setState] = React.useState({
        FindBooking: {
            bookingID: '',
            lastName: '',
            email: ''
        }
    });

    const [errorstate, seterrorstate] = React.useState({
        initialerrorstate: {
            bookingID: {
                errorstate: false,
                errortext: ""
            },
            lastName: {
                errorstate: false,
                errortext: ""
            },
            email: {
                errorstate: false,
                errortext: ""
            }
        }
    });

    //States Initializing End


    //Error Handling Start

    const [errorMsg, seterrorMsg] = React.useState('');

    const errorcancelhandle = () => {
        actionShopCartSetManageMyBooking(dispatch, false, false);
        actionResetBooking(dispatch);
        seterrorMsg('');
    }

    //Error Handling Start



    const reducerBooking = useSelector(state => state.reducerBooking);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const events = useSelector(state => state.reducerShopCart.events);
    const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    useEffect(() => {
        if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
            giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);


    useEffect(() => {
        if (reducerBooking.loading == true) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }
    })

    const constnextredirect = () => {
        props.history.push({
            pathname: '/managebooking'
        })
    }


    useEffect(() => {
        if (reducerBooking.booking !== 'nocontent' && reducerBooking.booking !== 'no-content') {
            reducerBooking.booking[0] = [];
        }
    }, [])

    useEffect(() => {

        if (reducerBooking.booking && reducerBooking.booking === "nocontent") {
            seterrorMsg(InvalidFindMyBookingFieldsErrorMsg);
            return;
        }

        if (reducerBooking.bookingError && reducerBooking.bookingError.length > 0) {
            seterrorMsg(reducerBooking.bookingError);
            return;
        }

        if (reducerBooking.booking && reducerBooking.booking.length > 0 && reducerBooking.booking[0].hasOwnProperty('BookingID')) {

            if (reducerBooking.booking[0].hasOwnProperty('BookingEmailAddress') && reducerBooking.booking[0].hasOwnProperty('BookingSearchName')) {
                if ((reducerBooking.booking[0].BookingSearchName.toLowerCase() !== state.FindBooking.lastName.toLowerCase()) &&
                    (reducerBooking.booking[0].BookingEmailAddress.toLowerCase() !== state.FindBooking.email.toLowerCase())) {

                    seterrorMsg('Last Name and Email does not match.');
                }
                else if (reducerBooking.booking[0].BookingSearchName.toLowerCase() !== state.FindBooking.lastName.toLowerCase()) {
                    seterrorMsg('Last Name does not match.');
                }

                else if (reducerBooking.booking[0].BookingEmailAddress.toLowerCase() !== state.FindBooking.email.toLowerCase()) {
                    seterrorMsg('Email does not match.');
                }
                else {
                    actionShopCartSetManageMyBooking(dispatch, true, false);
                    actionShopCartApplyMemberCostrate(dispatch, reducerBooking.booking[0].CustomerCostRateID, reducerBooking.booking[0].CustomerID, reducerBooking.booking[0].BookingEmailAddress, reducerBooking.booking[0].BookingSearchName);

                    constnextredirect();
                }
            }
            else {
                seterrorMsg('Last Name and Email does not match.');
                actionResetBooking(dispatch);
            }
        }
    }, [reducerBooking]);


    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    const paramBookingid = useQuery().get("bookingID");
    const paramName = useQuery().get("Name");
    const paramEmail = useQuery().get("Email");

    useEffect(() => {

        if ((paramBookingid && paramBookingid.trim().length > 0) && (paramName && paramName.trim().length > 0) && (paramEmail && paramEmail.trim().length > 0)) {
            var findBookingObj = { ...state.FindBooking };
            findBookingObj.bookingID = paramBookingid;
            findBookingObj.lastName = paramName;
            findBookingObj.email = paramEmail;
            setState({ ...state, FindBooking: findBookingObj });

            actionGetBooking(dispatch, paramBookingid, paramEmail, paramName);
        }
    }, [])

    const fieldhandleChange = (event) => {

        var findBookingObj = { ...state.FindBooking };

        if (event.target.name === "bookingID") {
            findBookingObj.bookingID = event.target.value;
            setState({ ...state, FindBooking: findBookingObj });
        }

        if (event.target.name === "lastname") {
            findBookingObj.lastName = event.target.value;
            setState({ ...state, FindBooking: findBookingObj });
        }

        if (event.target.name === "email") {
            findBookingObj.email = event.target.value;
            setState({ ...state, FindBooking: findBookingObj });
        }

    }

    const searchBooking = () => {

        if (orderProducts && orderProducts.length > 0) {
            seterrorMsg(OrderItemsInCartError);
            return;
        }

        var initialerrorstate = { ...errorstate.initialerrorstate };

        if (state.FindBooking.bookingID.trim().length < 1) {
            initialerrorstate.bookingID.errorstate = true;
            initialerrorstate.bookingID.errortext = "Booking ID is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.bookingID.errorstate = false;
            initialerrorstate.bookingID.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.FindBooking.lastName.trim().length < 1) {
            initialerrorstate.lastName.errorstate = true;
            initialerrorstate.lastName.errortext = "Last Name is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else {
            initialerrorstate.lastName.errorstate = false;
            initialerrorstate.lastName.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.FindBooking.email.trim().length < 1) {

            initialerrorstate.email.errorstate = true;
            initialerrorstate.email.errortext = "Email is required.";
            seterrorstate({ ...errorstate, initialerrorstate });
        }
        else if (state.FindBooking.email.trim().length > 0 && validateEmail(state.FindBooking.email) == false) {
            initialerrorstate.email.errorstate = true;
            initialerrorstate.email.errortext = "Please enter a valid email address.";
            seterrorstate({ ...errorstate, initialerrorstate });
            return;
        }
        else {
            initialerrorstate.email.errorstate = false;
            initialerrorstate.email.errortext = "";
            seterrorstate({ ...errorstate, initialerrorstate });
        }

        if (state.FindBooking.bookingID.trim().length > 0 && state.FindBooking.lastName.trim().length > 0 && state.FindBooking.email.trim().length > 0) {

            if (shopcartreducer.events && shopcartreducer.events.length > 0) {
                actionShopCartResetStateWithTourHold(dispatch, shopcartreducer.events);
            }

            if (shopcartreducer.donation && shopcartreducer.donation.length > 0) {
                actionShopCartResetDonation(dispatch);
            }

            actionGetBooking(dispatch, state.FindBooking.bookingID, state.FindBooking.email, state.FindBooking.lastName);
        }
    }

    function validateEmail(email) {
        var re = new RegExp(EmailRegex);
        return re.test(String(email).toLowerCase());
    }

    return (
        <Container className={classes.root} style={{ padding: "60px" }}>
            <ErrorHandling msg={errorMsg && errorMsg.length > 0 ? errorMsg : ''}
                open={errorMsg && errorMsg.length > 0 ? true : false} handleclose={errorcancelhandle} />
            <Grid
                container
                alignContent="center"
                className={classes.boxBorder}
                align="center"
                xs={12} md={6}
                justify="center"
                style={{ margin: "0px auto" }}
            >
                <Grid item xs={12} md={12} style={{ marginTop: -2 }}>
                    <Typography className={classes.tourheaderbox} align="center" variant="h2">
                        {FindMyBookingTitle}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={12} className={classes.itemPadding}>
                    <TextField
                        margin="dense"
                        name="bookingID"
                        id="bookingID"
                        label="Booking ID"
                        type={FindBookingIDNumberNumbericOnly ? "number" : "text"}
                        fullWidth={true}
                        value={state.FindBooking.bookingID}
                        onChange={fieldhandleChange}
                        error={errorstate.initialerrorstate.bookingID.errorstate}
                        helperText={errorstate.initialerrorstate.bookingID.errortext}
                    />
                </Grid>

                <Grid item xs={12} md={12} className={classes.itemPadding}>
                    <TextField
                        margin="dense"
                        name="lastname"
                        id="lastname"
                        label="Last Name"
                        fullWidth={true}
                        value={state.FindBooking.lastName}
                        onChange={fieldhandleChange}
                        error={errorstate.initialerrorstate.lastName.errorstate}
                        helperText={errorstate.initialerrorstate.lastName.errortext}
                    />
                </Grid>

                <Grid item xs={12} md={12} className={classes.itemPadding}>
                    <TextField
                        margin="dense"
                        name="email"
                        id="email"
                        label="Email"
                        fullWidth={true}
                        value={state.FindBooking.email}
                        onChange={fieldhandleChange}
                        error={errorstate.initialerrorstate.email.errorstate}
                        helperText={errorstate.initialerrorstate.email.errortext}
                    />
                </Grid>

                <Grid item xs={12} md={12} align="center" className={classes.searchButton}>
                    <Button className={classes.primarycolor} variant="contained" onClick={() => searchBooking()} size="large">
                        Search
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
};

export default FindMyBooking;